<script setup lang="ts">
import type { CheckboxRootEmits, CheckboxRootProps } from 'radix-vue'
import {
	CheckboxIndicator,
	CheckboxRoot,
	useForwardPropsEmits,
} from 'radix-vue'
import { cn } from '@/lib/utils'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const props = defineProps<CheckboxRootProps>()
const emits = defineEmits<CheckboxRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
	<CheckboxRoot
		v-bind="forwarded"
		:class="
			cn(
				'group peer h-20px w-20px shrink-0 rounded-sm border-2 border-n-950  ',
				'hover:border-o-500',
				'focus-visible:border-o-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffeed4bf]',
				'disabled:cursor-not-allowed disabled:border-n-300 disabled:bg-n-100',
				'data-[state=checked]:border-o-500 data-[state=checked]:bg-o-500 data-[state=checked]:text-white',
				'data-[state=checked]:disabled:border-n-300 data-[state=checked]:disabled:bg-n-300 data-[state=checked]:disabled:text-n-100',
				$attrs.class ?? '',
			)
		"
	>
		<CheckboxIndicator
			class="flex h-full w-full items-center justify-center text-current"
		>
			<BaseIcon
				name="check"
				class="h-full w-full text-n-50"
				group-disabled:hidden
			/>
		</CheckboxIndicator>
	</CheckboxRoot>
</template>
